import api from './api';

const supplierRequestsService = {
  // Get all supplier requests for the authenticated user
  getAll: async () => {
    const response = await api.get('/supplier-requests');
    return response.data;
  },

  // Submit a new supplier request
  submit: async (requestData) => {
    const response = await api.post('/supplier-requests', requestData);
    return response.data;
  },

  // Update supplier request status (admin only)
  updateStatus: async (requestId, statusData) => {
    const response = await api.put(`/supplier-requests/${requestId}/status`, statusData);
    return response.data;
  }
};

export default supplierRequestsService;
